// @flow

import type { UiPopup } from 'redux/type/uiPopup'
import type { State } from 'redux/type'

import React from 'react'
import { connect } from 'react-redux'
import { dispatch } from 'redux/store'
import AlertPopup from './AlertPopup'
import WxSharePopup from './WxSharePopup'
import Error from './Error'
import Toast from './Toast'
import Loading from './Loading'

function openPopup (params: UiPopup) {
  dispatch({
    type: 'UI_POPUP',
    ...params
  })
}

function closePopup () {
  dispatch({ type: 'UI_POPUP_CLOSE' })
}

type AlertParam = {
  message?: string,
  title?: string,
  dangerousHtml?: string,
  ok?: string
};

function alert (opts: string | AlertParam): Promise<void> {
  const realOpts: AlertParam =
    typeof opts === 'string' ? { message: opts } : opts

  return new Promise(resolve => {
    openPopup({
      popupType: 'alert',
      ...realOpts,
      onOk () {
        closePopup()
        resolve()
      }
    })
  })
}

type ConfirmParam = {
  message: string,
  title?: string,
  ok?: string,
  cancel?: string,
  isModal?: boolean,
  dangerousHtml?: string
};

function confirm (opts: string | ConfirmParam): Promise<boolean> {
  const realOpts: ConfirmParam =
    typeof opts === 'string' ? { message: opts } : opts

  return new Promise(resolve => {
    openPopup({
      popupType: 'confirm',
      ...realOpts,
      onOk () {
        closePopup()
        resolve(true)
      },
      onCancel () {
        closePopup()
        resolve(false)
      }
    })
  })
}

function toast (message: string) {
  openPopup({
    popupType: 'toast',
    message
  })
  setTimeout(closePopup, 2500)
}

function loading<T> (promise: Promise<T>, message?: string): Promise<T> {
  openPopup({
    popupType: 'loading',
    message
  })

  return promise
    .then((value: T) => {
      closePopup()
      return value
    })
    .catch(e => {
      closePopup()
      throw e
    })
}

function alertError (message: string) {
  openPopup({
    popupType: 'alerError',
    message
  })
  setTimeout(closePopup, 2500)
}

class Popup extends React.Component<{
  uiPopup: UiPopup
}> {
  render () {
    let { uiPopup } = this.props
    switch (uiPopup.popupType) {
      case 'alert':
      case 'confirm':
        return <AlertPopup uiPopup={uiPopup} />
      case 'toast':
        return <Toast uiPopup={uiPopup} />
      case 'loading':
        return <Loading uiPopup={uiPopup} />
      case 'wxShare':
        return <WxSharePopup uiPopup={uiPopup} />
      case 'alerError':
        return <Error uiPopup={uiPopup} />
      default:
        return null
    }
  }
}

function mapStateToProps (state: State) {
  return {
    uiPopup: state.uiPopup
  }
}

function wxShare (): Promise<void> {
  return new Promise(resolve => {
    openPopup({
      popupType: 'wxShare',
      onOk () {
        closePopup()
        resolve()
      }
    })
  })
}
wxShare.close = closePopup

const PopupComponent = connect(mapStateToProps)(Popup)

export { alert, confirm, toast, loading, PopupComponent, wxShare, alertError }



// WEBPACK FOOTER //
// ./src/frame/ui/popup/index.js